import React, { ChangeEventHandler } from 'react';

export interface CheckBoxInputProps {
  value?: boolean;
  onChange?: ChangeEventHandler | undefined;
  invalid?: boolean;
  label?: string;
  id?: string;
}

const CheckBoxInput: React.FC<CheckBoxInputProps> = ({
  value,
  onChange,
  label = '',
  id = 'checkbox',
}) => {
  return (
    <label htmlFor={id} className="flex items-center">
      <div
        className="toggle-switch"
        style={{
          position: 'relative',
          display: 'inline-block',
          width: '40px',
          height: '26px',
          // @ts-ignore
          ' input': {
            opacity: 0,
            width: 0,
            height: 0,
          },
        }}
      >
        <input
          id={id}
          type="checkbox"
          name={id}
          checked={value === true}
          onChange={onChange}
          hidden
        />
        <span className="slider round"></span>
      </div>
      <span className="ml-2 block text-xs leading-5 text-gray-450">
        {label}
      </span>
    </label>
  );
};

export default CheckBoxInput;
